import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Progress } from "reactstrap";

const CompanyFormCompletion = ({ formData }) => {
  const [compeletionPercentage, setCompletionPercentage] = useState(0);

useEffect(() => {
  let score = 0;

  if (formData?.name) score += 10;

  if (formData?.emailAddress) score += 10;

  if (formData?.mobileNumber) score += 10;

  if (formData?.jobLocationId) score += 10;

  if (formData?.companyDetails) score += 10;

  if (formData?.companyAddress) score += 10;

  if (formData?.logo) score += 5;

  // ✅ updated fields
  if (formData?.ownerName) score += 5;
  if (formData?.totalEmployees) score += 5;
  if (formData?.contactNumber) score += 2;
  if (formData?.establishmentYear) score += 3;
  if (formData?.websiteUrl) score += 5;
  if (formData?.gstNumber) score += 5;
  if (formData?.mapLocation) score += 5;
  if (formData?.workingDays) score += 5;

  setCompletionPercentage(score);
}, [formData]);

  return (
    <>
      <div className='form-progress-sec'>
        <Progress
          value={compeletionPercentage}
          color={compeletionPercentage === 100 ? "success" : "primary"}
        >
          {compeletionPercentage}%
        </Progress>
      </div>
    </>
  );
};

export default CompanyFormCompletion;
